const isProd = process.env.REACT_APP_STAGE === "prod";

export const trackSubmitApplication = () => {
  if (!isProd) return;
  if (window.fbq) {
    window.fbq("track", "Submit application");
  }
};

export const trackLead = () => {
  if (!isProd) return;
  if (window.fbq) {
    window.fbq("track", "Lead");
  }
  if (window.gtag) {
    window.gtag("event", "conversion", { send_to: "AW-18024560536/JIbaCOiP9IocEJjv45JD" });
  }
};
